<template>
  <span :class="iconClass" :title="statusLabel">
    <i :class="icon"></i>
  </span>
</template>

<script>
export default {
  name: "StatusIcon",
  props: {
    status: {
      type: String,
      required: true,
    },
  },
  computed: {
    icon() {
      switch (this.status) {
        case "active":
          return "bi bi-check-circle-fill";
        case "inactive":
          return "bi bi-x-circle-fill";
        case "pending":
          return "bi bi-hourglass-split";
        case "archived":
          return "bi bi-archive-fill";
        default:
          return "bi bi-question-circle-fill";
      }
    },
    iconClass() {
      switch (this.status) {
        case "active":
          return "status-icon active";
        case "inactive":
          return "status-icon inactive";
        case "pending":
          return "status-icon pending";
        case "archived":
          return "status-icon archived";
        default:
          return "status-icon unknown";
      }
    },
    statusLabel() {
      switch (this.status) {
        case "active":
          return "Active";
        case "inactive":
          return "Inactive";
        case "pending":
          return "Pending";
        case "archived":
          return "Archived";
        default:
          return "Unknown";
      }
    },
  },
};
</script>

<style scoped>
.status-icon {
  display: inline-flex;
  align-items: center;
  font-size: 1.2em;
  margin-right: 0.25em;
}

.status-icon.active {
  color: #28a745;
}

.status-icon.inactive {
  color: #dc3545;
}

.status-icon.pending {
  color: #ffc107;
}

.status-icon.archived {
  color: #6c757d;
}

.status-icon.unknown {
  color: #adb5bd;
}
</style>
